import { Box, Button, Container, Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
import globalContext from '../../context/context'
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { CssTextField } from "../../utils/CssTextField";
import { Delete } from "@mui/icons-material";
import LoginComponent from "../authentication/LoginComponent";
import RegisterComponent from "../authentication/RegisterComponent";
import WalletPrice from "../../utils/WalletPrice";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { isInCart } from "../../utils/cart";

const convertDate = (dateO) => {

    if(!dateO){
        return;
    }

    let finalDate = new Date();
    if (dateO?.toString() == dateO) {
        finalDate = new Date( dateO );
    } else {
        finalDate = new Date( dateO?.toISOString() )
    }

    finalDate = new Date( finalDate?.getTime() + (new Date().getTimezoneOffset()*-1*60000) );
    return finalDate?.toISOString()?.substring(0, 19)
}

function CartStepOne() {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const { contextData: { details, cart, cartSum, transfer, parking, lounge, fastTrack, currency, user, formValues }, setDetails, setCart, isLoggedIn, addToCart: globalAddToCart } = useContext(globalContext);

    const [showLogin, setShowLogin] = useState(true);

    const navigateToPage = (name) => {
        navigate(`/${name}`);
    } 

    useEffect(() => {
        if (cart?.id) {

            if (formValues) {
                setDetails({
                    ...details,
                    flightArrival: convertDate(formValues?.arrivalSideEndDate),
                    flightDeparture: convertDate(formValues?.departureSideStartDate),
                    flightArrival2: convertDate(formValues?.departureSideEndDate),
                    flightDeparture2: convertDate(formValues?.arrivalSideStartDate),
                }, cart?.id)
            }
        }
    }, [cart])


    useEffect(() => {
        if (user?.id) {
            let detailsFromUser = {};
            if (!cart?.surname) {
                detailsFromUser.surname = user.lastName;
            }
            if (!cart?.firstname) {
                detailsFromUser.firstname = user.firstName;
            }
            if (!cart?.email) {
                detailsFromUser.email = user.email;
            }

            setDetails({
                ...details,
                flightArrival: convertDate(formValues?.arrivalSideEndDate),
                flightDeparture: convertDate(formValues?.departureSideStartDate),
                flightArrival2: convertDate(formValues?.departureSideEndDate),
                flightDeparture2: convertDate(formValues?.arrivalSideStartDate),
                ...detailsFromUser
            }, cart?.id);
        }
    }, [user])


    const setDetailsChange = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value }, cart?.id);
    }

    const getName = (type) => {

        if (type === 'parking' && parking && parking[0]) {
            return parking[0]?.name
        }

        if (type === 'transfer' && transfer && transfer[0]) {
            return transfer[0]?.name
        }

        if (type === 'lounge' && lounge && lounge[0]) {
            return lounge[0]?.name
        }

        if (type === 'fast-track' && fastTrack && fastTrack[0]) {
            return fastTrack[0]?.name
        }

    }

    const getPrice = (type) => {

        if (type === 'parking' && parking && parking[0]) {
            return parking[0]?.priceInCurrency + " " + parking[0]?.currency
        }

        if (type === 'transfer' && transfer && transfer[0]) {
            return transfer[0]?.priceInCurrency + " " + transfer[0]?.currency
        }

        if (type === 'lounge' && lounge && lounge[0]) {
            return lounge[0]?.priceInCurrency + " " + lounge[0]?.currency
        }

        if (type === 'fast-track' && fastTrack && fastTrack[0]) {
            return fastTrack[0]?.priceInCurrency + " " + fastTrack[0]?.currency
        }

    }

    const getObj = (type) => {

        if (type === 'parking' && parking && parking[0]) {
            return parking[0]
        }

        if (type === 'transfer' && transfer && transfer[0]) {
            return transfer[0]
        }

        if (type === 'lounge' && lounge && lounge[0]) {
            return lounge[0]
        }

        if (type === 'fast-track' && fastTrack && fastTrack[0]) {
            return fastTrack[0]
        }

    }

    const shouldType = (type) => {

        if (
            type === 'parking'
            &&
            parking && parking[0]
            &&
            !(cart?.directionFrom?.departureParking || cart?.directionTo?.departureParking)
        ) {
            return true;
        }

        if (
            type === 'transfer'
            && transfer && transfer[0]
            &&
            !(cart?.directionFrom?.arrivalTransfer
                || cart?.directionFrom?.departureTransfer
                || cart?.directionTo?.departureTransfer
                || cart?.directionTo?.arrivalTransfer)
        ) {
            return true;
        }

        if (
            type === 'lounge'
            && lounge && lounge[0]
            &&
            !(cart?.directionFrom?.departureLounge || cart?.directionTo?.departureLounge)
        ) {
            return true;
        }

        if (
            type === 'fast-track'
            && fastTrack && fastTrack[0]
            &&
            !(cart?.directionFrom?.departureFastTrack || cart?.directionTo?.departureFastTrack)
        ) {
            return true;
        }

        return false;

    }

    const deleteItem = (suffix, id) => {
        let idVariable = 'loungeId';
        if (suffix.includes('transfer')) {
            idVariable = 'transferId'
        } else if (suffix.includes('parking')) {
            idVariable = 'parkingId'
        } else if (suffix.includes('fast-track')) {
            idVariable = 'fastTrackId'
        }
        axios.put(`/api/custom/shopping-carts/${cart?.id}/${suffix}?${idVariable}=${id}&currency=${currency}`)
            .then(res => {
                if (res?.data) {
                    setCart(res?.data);
                }
            }).catch(err => console.log(err))
    }


    return (
        <>
            {cart?.id ? <Container disableGutters sx={{ pt: 4 }}>

                <Box sx={{ fontSize: 16, pb: 4 }}>
                    {t('cart.fillDetails')}
                </Box>

                <Grid spacing={2} container>
                    <Grid xs={12} md={6} item>
                        <Box sx={{ p: 3, color: '#000', border: '2px solid #ea0089', borderRadius: '10px' }}>

                            {isLoggedIn() ? null : <>
                                <Box sx={{ pb: 1, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>{t('cart.signUpIn')}</Box>
                                <Box sx={{ pb: 3 }}>
                                    {showLogin
                                        ?
                                        <>
                                            <LoginComponent />
                                            <Button sx={{ ml: 2, width: { xs: '100%', md: 'initial' } }} onClick={() => setShowLogin(false)} variant="text">{t('cart.dontHaveAccount')}</Button>
                                            <br />
                                            <Button size="small" sx={{ mt: 1, width: { xs: '100%', md: 'initial' }, textAlign: 'center' }} component={Link} to="/forgot-password" variant="text">Did you forget your password?</Button>
                                        </>
                                        : <>
                                            <RegisterComponent />
                                            <Button sx={{ ml: 2, width: { xs: '100%', md: 'initial' } }} onClick={() => setShowLogin(true)} variant="text">{t('cart.alreadyHaveAccount')}</Button>
                                        </>}

                                </Box>
                            </>}

                            <Box sx={{ pb: 1, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>{t('cart.leadPassengerData')}</Box>
                            <CssTextField
                                size="small"
                                sx={{ mt: 1 }}
                                value={details?.surname}
                                name="surname"
                                onChange={setDetailsChange}
                                fullWidth
                                variant="standard"
                                label={t('cart.surname')} />
                            <CssTextField size="small"
                                value={details?.firstname}
                                name="firstname"
                                onChange={setDetailsChange}
                                sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.firstname')} />
                            <CssTextField size="small"
                                value={details?.email}
                                name="email"
                                onChange={setDetailsChange}
                                sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.email')} />
                            <CssTextField size="small"
                                value={details?.phone}
                                name="phone"
                                onChange={setDetailsChange}
                                sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.phone')} />

                            <Box sx={{ pb: 1, pt: 5, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>{t('cart.flightData')}</Box>
                            <CssTextField size="small"
                                value={details?.flightNumber}
                                name="flightNumber"
                                onChange={setDetailsChange}
                                sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.flightNumber')} required />

                            <CssTextField size="small"
                                value={details?.flightDeparture}
                                name="flightDeparture"
                                type="datetime-local"
                                onChange={setDetailsChange}
                                sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.flightDeparture')} />

                            <CssTextField size="small"
                                value={details?.flightArrival}
                                type="datetime-local"
                                name="flightArrival"
                                onChange={setDetailsChange}
                                sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.flightArrival')} />

                            {!formValues?.singleTrip && <>
                                <strong style={{ marginTop: '10px', display: 'inline-block' }}>Return:</strong>

                                <CssTextField size="small"
                                    value={details?.flightNumber2}
                                    name="flightNumber2"
                                    onChange={setDetailsChange}
                                    sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.flightNumber')} required />

                                <CssTextField size="small"
                                    value={details?.flightDeparture2}
                                    name="flightDeparture2"
                                    type="datetime-local"
                                    onChange={setDetailsChange}
                                    sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.flightDeparture')} />

                                <CssTextField size="small"
                                    value={details?.flightArrival2}
                                    type="datetime-local"
                                    name="flightArrival2"
                                    onChange={setDetailsChange}
                                    sx={{ mt: 1 }} fullWidth variant="standard" label={t('cart.flightArrival')} />

                            </>}

                        </Box>
                    </Grid>
                    <Grid xs={12} md={6} item>
                        <Box sx={{ border: '2px solid #f6c3ca', borderRadius: '10px' }}>
                            <Box sx={{ p: { xs: 2, md: 4 }, color: '#000', background: '#f6c3ca', border: '2px solid #f6c3ca', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                <Box sx={{ pb: 1, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>{t('cart.walletFunds')}: <WalletPrice /></Box>
                                <Box sx={{ pt: 1, fontWeight: 900, fontSize: 16, color: '#000' }}>
                                    {cart?.directionFrom?.departureTransfer && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionFrom?.departureTransfer?.quantity} x {cart?.directionFrom?.departureTransfer?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionFrom?.departureTransfer?.priceInCurrency} {cart?.directionFrom?.departureTransfer?.currency}
                                            <IconButton onClick={() => deleteItem('delete-transfer', cart?.directionFrom?.departureTransfer?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}
                                    {cart?.directionFrom?.arrivalTransfer && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionFrom?.arrivalTransfer?.quantity} x {cart?.directionFrom?.arrivalTransfer?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionFrom?.arrivalTransfer?.priceInCurrency} {cart?.directionFrom?.arrivalTransfer?.currency}
                                            <IconButton onClick={() => deleteItem('delete-transfer', cart?.directionFrom?.arrivalTransfer?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}
                                    {cart?.directionFrom?.departureLounge && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionFrom?.departureLounge?.quantity} x {cart?.directionFrom?.departureLounge?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionFrom?.departureLounge?.priceInCurrency} {cart?.directionFrom?.departureLounge?.currency}
                                            <IconButton onClick={() => deleteItem('delete-lounge', cart?.directionFrom?.departureLounge?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}
                                    {cart?.directionFrom?.departureParking && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionFrom?.departureParking?.quantity} x {cart?.directionFrom?.departureParking?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionFrom?.departureParking?.priceInCurrency} {cart?.directionFrom?.departureParking?.currency}
                                            <IconButton onClick={() => deleteItem('delete-parking', cart?.directionFrom?.departureParking?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}

                                    {cart?.directionTo?.departureTransfer && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionTo?.departureTransfer?.quantity} x {cart?.directionTo?.departureTransfer?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionTo?.departureTransfer?.priceInCurrency} {cart?.directionTo?.departureTransfer?.currency}
                                            <IconButton onClick={() => deleteItem('delete-transfer', cart?.directionTo?.departureTransfer?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}
                                    {cart?.directionTo?.arrivalTransfer && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionTo?.arrivalTransfer?.quantity} x {cart?.directionTo?.arrivalTransfer?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionTo?.arrivalTransfer?.priceInCurrency} {cart?.directionTo?.arrivalTransfer?.currency}
                                            <IconButton onClick={() => deleteItem('delete-transfer', cart?.directionTo?.arrivalTransfer?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}
                                    {cart?.directionTo?.departureLounge && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionTo?.departureLounge?.quantity} x {cart?.directionTo?.departureLounge?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionTo?.departureLounge?.priceInCurrency} {cart?.directionTo?.departureLounge?.currency}
                                            <IconButton onClick={() => deleteItem('delete-lounge', cart?.directionTo?.departureLounge?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}
                                    {cart?.directionTo?.departureParking && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionTo?.departureParking?.quantity} x {cart?.directionTo?.departureParking?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionTo?.departureParking?.priceInCurrency} {cart?.directionTo?.departureParking?.currency}
                                            <IconButton onClick={() => deleteItem('delete-parking', cart?.directionTo?.departureParking?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}
                                    {cart?.directionTo?.departureFastTrack && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionTo?.departureFastTrack?.quantity} x {cart?.directionTo?.departureFastTrack?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionTo?.departureFastTrack?.priceInCurrency} {cart?.directionTo?.departureFastTrack?.currency}
                                            <IconButton onClick={() => deleteItem('delete-fast-track', cart?.directionTo?.departureFastTrack?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}
                                    {cart?.directionFrom?.departureFastTrack && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={7} item>{cart?.directionFrom?.departureFastTrack?.quantity} x {cart?.directionFrom?.departureFastTrack?.name}</Grid>
                                        <Grid xs={5} sx={{ textAlign: 'right' }} item>
                                            {cart?.directionFrom?.departureFastTrack?.priceInCurrency} {cart?.directionFrom?.departureFastTrack?.currency}
                                            <IconButton onClick={() => deleteItem('delete-fast-track', cart?.directionFrom?.departureFastTrack?.id)} size="small" color="error"><Delete /></IconButton>
                                        </Grid>
                                    </Grid>}

                                </Box>
                            </Box>
                            <Box sx={{ px: { xs: 2, md: 4 }, py: 1, color: '#000' }}>
                                <Box sx={{ pt: 1, fontWeight: 900, fontSize: 16, color: '#000' }}>
                                    <Grid direction="row"
                                        justifyContent="space-between"
                                        alignItems="top" container>
                                        <Grid xs={7} item>
                                            {cartSum?.promotionInCurrency ? <>
                                                <small style={{ fontWeight: 'normal' }}>{t("cart.promotionDiscount")}</small>
                                                <br />
                                                {t("cart.totalPaid")}
                                            </> : <>
                                                {t("cart.totalPaid")}
                                            </>}
                                            {!!cartSum?.transactionFeeInCurrency && <>
                                                <br />
                                                <small style={{ fontWeight: 'normal' }}><strong>{cartSum?.transactionFeeInCurrency} {currency}</strong> {t("cart.transactionFee")}</small>
                                            </>}
                                        </Grid>
                                        <Grid xs={5} style={{ textAlign: 'right' }} item>

                                            {cartSum?.promotionInCurrency ? <>
                                                <small style={{ fontWeight: 'bold' }}>{cartSum?.promotionInCurrency} {currency}</small>
                                                <br />
                                                <small style={{ textDecoration: 'line-through', fontWeight: 'normal' }}>{cartSum?.priceInCurrency} {currency}</small> {cartSum?.priceWithPromotionAndTransactionFeeInCurrency} {currency}
                                            </> : <>
                                                {cartSum?.priceWithPromotionAndTransactionFeeInCurrency} {currency}
                                            </>}
                                            <br />
                                            <small style={{ fontWeight: 'normal' }}>{t("cart.vatIncl")}</small>
                                        </Grid>
                                    </Grid>

                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ px: 0, py: 1, color: '#333' }}>
                            <Box sx={{ py: 2, fontWeight: 600, fontSize: 16 }}>
                                {[
                                    {
                                        name: 'parking',
                                        icon: '/images/airport_parking.png'

                                    },
                                    {
                                        name: 'transfer',
                                        icon: '/images/airport_transfer.png'

                                    },
                                    {
                                        name: 'fast-track',
                                        icon: '/images/fast_track.png'

                                    },
                                    {
                                        name: 'lounge',
                                        icon: '/images/lounge.png'

                                    }
                                ].filter((t) => shouldType(t.name))
                                    .map((ex, exKey) => <Box
                                        key={exKey}
                                        onClick={() => navigateToPage(ex.name)}
                                        sx={{
                                            border: '2px solid #ea0089',
                                            pl: 2,
                                            borderRadius: '10px',
                                            mt: 2,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            cursor: 'pointer'
                                        }}>
                                        <Box sx={{ width: 'calc( 100% - 80px )' }}>
                                            <Grid direction="row"
                                                justifyContent="space-between"
                                                sx={{ py: 3, pr: 2 }}
                                                alignItems="center" container>
                                                <Grid xs={8} item>{getName(ex.name)}</Grid>
                                                <Grid xs={4} sx={{ fontWeight: 'normal', textAlign: 'right' }} item>{getPrice(ex.name)}</Grid>
                                            </Grid>
                                        </Box>
                                        <Box sx={{
                                            width: '80px',
                                            backgroundImage: `url('${ex.icon}')`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                        }}></Box>
                                    </Box>)}


                            </Box>
                        </Box>
                    </Grid>
                </Grid>

            </Container> : <Box sx={{ textAlign: 'center', p: 5, fontWeight: 'bold', fontSize: '1.2rem' }}>{t("cart.emptyCart")}</Box>}

        </>
    );
}

export default CartStepOne;
